module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/icon_under-7669ec0fd2ead151c28311ca0e54a345.svg";